// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1N1yy","image-element":"_90pUt","attribution":"_1QlGP","image-title":"VbgI7"};